import { combineReducers } from 'redux';

import base from './base/reducer';

export default combineReducers({
  base,
});
